<template>
  <div>
    <template>
      <el-table
        :data="tableData"
        :span-method="objectSpanMethod"
        :fit="true"
        @selection-change="selectionChange"
        border
        class="multifunctional-table dic-sub-table-style01"
      >
        <el-table-column
          type="index"
          :width="commonTableWidth.serialNoWidth"
          :label="$t('page.content.serialNo')"
          align="center"
        >
          <template #default="scope">
            <span class="tips">完成登录后即可查看</span>
          </template>
        </el-table-column>
        <template v-for="(table, index) in tableHead">
          <el-table-column
            :key="index"
            :label="table.label"
            :width="table.width"
            :min-width="table.width"
            :prop="table.prop"
            :align="table.align"
            :header-align="table.headerAlign"
            :show-overflow-tooltip="true"
            :formatter="table.formatter"
            v-if="!table.isHidden"
          >
            <template #default="scope">
              <span class="tips">完成登录后即可查看</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
     
    </template>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/basa/utils";
import { commonTableWidth } from "@/setting/setting";
export default {
  name: "detail-table",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableHead: {
      type: Array,
      default: () => [],
    },
    showCheckBox: {
      type: Boolean,
      default: false,
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      commonTableWidth: commonTableWidth,
    };
  },
  methods: {
    selectionChange(selection) {
      this.$emit("selectionChange", selection);
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, this.tableHead.length+1];
      } else{
        return [0, 0];
      }
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
  },
};
</script>

<style scoped lang="scss">
.tips {
  color: #eb090c;
  font-size: 14px;
    display: block;
    line-height: 60px;
}
</style>
